import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { PHASES, PHASE_COLOR } from './PhaseTimeline';

const PHASE_LABELS = Object.fromEntries(PHASES.map(p => [p.key, p.label]));

const OpportunityCard = ({ opportunity, onAdvancePhase }) => {
  const navigate = useNavigate();
  const phase = opportunity.phase || 'exploration';
  const color = PHASE_COLOR[phase] || '#E27B58';
  const currentIndex = PHASES.findIndex(p => p.key === phase);
  const nextPhase = PHASES[currentIndex + 1];

  return (
    <div
      style={{
        background: 'rgba(10, 14, 22, 0.9)',
        border: `1px solid ${color}44`,
        borderLeft: `3px solid ${color}`,
        borderRadius: '8px',
        padding: '14px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        marginBottom: '8px',
      }}
      onMouseOver={(e) => { e.currentTarget.style.borderColor = `${color}88`; e.currentTarget.style.background = `rgba(10,14,22,0.98)`; }}
      onMouseOut={(e) => { e.currentTarget.style.borderColor = `${color}44`; e.currentTarget.style.background = `rgba(10,14,22,0.9)`; }}
      onClick={() => navigate(`/opportunities/${opportunity._id}`)}
    >
      {/* Name */}
      <div style={{
        fontSize: '0.9rem',
        fontWeight: '700',
        color: '#F0F0F0',
        marginBottom: '6px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}>
        {opportunity.name}
      </div>

      {/* Address */}
      {opportunity.address && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          fontSize: '0.72rem',
          color: '#666',
          marginBottom: '10px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          <MapPin size={11} />
          {opportunity.address}
        </div>
      )}

      {/* Footer */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{
          fontSize: '0.65rem',
          color,
          background: `${color}15`,
          border: `1px solid ${color}44`,
          padding: '2px 8px',
          borderRadius: '4px',
          fontWeight: '600',
          textTransform: 'uppercase',
        }}>
          {PHASE_LABELS[phase] || phase}
        </span>

        {nextPhase && onAdvancePhase && (
          <button
            onClick={(e) => { e.stopPropagation(); onAdvancePhase(opportunity._id, nextPhase.key); }}
            title={`Avanzar a ${nextPhase.label}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              background: 'transparent',
              border: `1px solid ${nextPhase.color}55`,
              borderRadius: '4px',
              color: nextPhase.color,
              fontSize: '0.65rem',
              padding: '3px 8px',
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}
            onMouseOver={(e) => { e.currentTarget.style.background = `${nextPhase.color}18`; }}
            onMouseOut={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            {nextPhase.label} <ArrowRight size={10} />
          </button>
        )}
      </div>
    </div>
  );
};

export default OpportunityCard;
